import React from "react";
import { ArrowRight, Instagram } from "lucide-react";

export default function ContactSection() {
  return (
    <section id="contact" className="bg-[color:var(--dms-navy)] py-24">
      <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
        <p className="kicker">Contact</p>
        <h2 className="font-serif text-4xl md:text-5xl text-white mt-4">Let's put your story on a shirt</h2>
        <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mx-auto mt-5" />
        <p className="mt-6 text-white/75">Start with a design, a verse, or just a rough idea and a date you need it by. We'll take it from there.</p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#custom" className="btn-peach">Start Your Design <ArrowRight className="w-4 h-4" /></a>
          <a href="#contact" className="btn-outline-light">Message Us</a>
        </div>
        <p className="mt-8 text-white/55 text-sm flex items-center justify-center gap-2">
          We reply to every message within one business day.  ·  <Instagram className="w-4 h-4" /> @design.my.story
        </p>
      </div>
    </section>
  );
}
